<template>
  <v-container fluid ma-0 pa-0>
    <v-layout row>
      <v-flex xs12>
        <div class="pagecontainer">
          <v-layout row class="mediumMargin layouttitletop">
            <v-flex xs10>
              <span class="header-title">{{header}}</span>
            </v-flex>
             <v-flex xs2>
              <v-btn v-if="canCreateResource" color="primary" @click="newResource">{{newResourceButtonLabel}} <span class="icon-plus"></span></v-btn>
            </v-flex>
          </v-layout>
        </div>
        <v-layout row>
          <v-flex xs6 offset-xs3>
            <span>
              <v-img :src="imageEmptyCoversUrl" class="emptycovers"></v-img>
            </span>
          </v-flex>
        </v-layout>
        <v-layout row>
          <span class="emptycoverstext">{{description}}</span>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
export default {
  props: ['header', 'description', 'canCreateResource', 'newResourceButtonLabel'],
  data () {
    return {
      imageEmptyCoversUrl: require(`@/assets/img/${process.env.VUE_APP_NODE_ENV_API}/empty-covers.svg`)
    }
  },
  methods: {
    newResource () {
      this.$emit('createNewResource')
    }
  }
}
</script>
